import React, { useState } from 'react';
import { useStartCampaignMutation } from '../../api/emailCampaignApi';
import { toast } from 'react-toastify';
import './EmailTemplateEditor.css';

const EmailTemplateEditor = () => {
    const [subject, setSubject] = useState('Hoş Geldiniz - MyCourse Galaxy');
    const [campaignName, setCampaignName] = useState('Email Kampanyası');
    const [emailList, setEmailList] = useState('');
    const [bodyContent, setBodyContent] = useState('Merhaba!\n\nSize özel fırsatlarımız hakkında bilgi vermek istiyoruz.');
    const [htmlTemplate, setHtmlTemplate] = useState('<!DOCTYPE html>\n' +
'<html lang="tr">\n' +
'<head>\n' +
'    <meta charset="UTF-8">\n' +
'    <meta name="viewport" content="width=device-width, initial-scale=1.0">\n' +
'    <title>Email</title>\n' +
'</head>\n' +
'<body style="margin: 0; padding: 0; background-color: #f4f4f4; font-family: Arial, sans-serif;">\n' +
'    <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f4f4f4; padding: 20px;">\n' +
'        <tr>\n' +
'            <td align="center">\n' +
'                <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">\n' +
'                    <!-- Header -->\n' +
'                    <tr>\n' +
'                        <td style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 40px 30px; text-align: center;">\n' +
'                            <h1 style="color: #ffffff; margin: 0; font-size: 28px;">🎓 MyCourse Galaxy</h1>\n' +
'                        </td>\n' +
'                    </tr>\n' +
'                    \n' +
'                    <!-- Content -->\n' +
'                    <tr>\n' +
'                        <td style="padding: 40px 30px;">\n' +
'                            <h2 style="color: #333333; margin-top: 0;">Merhaba!</h2>\n' +
'                            <div style="color: #666666; font-size: 16px; line-height: 1.6;">\n' +
'                                ' + '{{content}}' + '\n' +
'                            </div>\n' +
'                            \n' +
'                            <!-- CTA Button -->\n' +
'                            <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 30px;">\n' +
'                                <tr>\n' +
'                                    <td align="center">\n' +
'                                        <a href="' + '{{verification_link}}' + '" style="display: inline-block; background-color: #667eea; color: #ffffff; padding: 14px 40px; text-decoration: none; border-radius: 6px; font-weight: 600; font-size: 16px;">\n' +
'                                            Hemen İncele\n' +
'                                        </a>\n' +
'                                    </td>\n' +
'                                </tr>\n' +
'                            </table>\n' +
'                        </td>\n' +
'                    </tr>\n' +
'                    \n' +
'                    <!-- Footer -->\n' +
'                    <tr>\n' +
'                        <td style="background-color: #f6f9fc; padding: 30px; text-align: center;">\n' +
'                            <p style="color: #8898aa; font-size: 14px; margin: 0;">\n' +
'                                MyCourse Galaxy - Eğitimde Yeni Bir Çağ\n' +
'                            </p>\n' +
'                            <p style="color: #8898aa; font-size: 12px; margin-top: 10px;">\n' +
'                                © 2026 Tüm hakları saklıdır.\n' +
'                            </p>\n' +
'                        </td>\n' +
'                    </tr>\n' +
'                </table>\n' +
'            </td>\n' +
'        </tr>\n' +
'    </table>\n' +
'</body>\n' +
'</html>');

    const [showPreview, setShowPreview] = useState(false);
    const [activeTab, setActiveTab] = useState('editor'); // 'editor' veya 'preview'
    
    const [startCampaign, { isLoading }] = useStartCampaignMutation();

    // Email validasyonu
    const parseEmails = (text) => {
        const emails = text
            .split(/[\n,;]/)
            .map(email => email.trim())
            .filter(email => {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(email);
            });
        return emails;
    };

    // Template önizleme
    const getPreviewHtml = () => {
        return htmlTemplate
            .replace(/{{subject}}/g, subject)
            .replace(/{{content}}/g, bodyContent.replace(/\n/g, '<br>'))
            .replace(/{{body}}/g, bodyContent.replace(/\n/g, '<br>'))
            .replace(/{{verification_link}}/g, '#');
    };

    // Kampanya gönder
    const handleSendCampaign = async () => {
        const emails = parseEmails(emailList);
        
        if (emails.length === 0) {
            toast.error('Lütfen geçerli email adresleri girin!');
            return;
        }

        if (!subject.trim()) {
            toast.error('Lütfen email konusu girin!');
            return;
        }

        if (!htmlTemplate.trim()) {
            toast.error('Lütfen HTML template girin!');
            return;
        }

        try {
            const recipients = emails.map(email => ({
                Email: email,
                Subject: subject,
                Body: bodyContent,
                HtmlTemplate: htmlTemplate,
                CampaignName: campaignName
            }));

            console.log('Gönderiliyor:', recipients);
            
            const response = await startCampaign(recipients).unwrap();
            
            if (response.success) {
                toast.success(`✅ Kampanya başlatıldı! ${emails.length} email gönderiliyor...`);
                toast.info(`📊 Kampanya ID: ${response.data.reportId}`);
                
                // Formu temizle
                setEmailList('');
                setActiveTab('editor');
            }
        } catch (error) {
            console.error('Kampanya hatası:', error);
            toast.error('❌ Kampanya başlatılamadı: ' + (error?.data?.message || error.message));
        }
    };

    // Hazır template'ler
    const loadTemplate = (templateType) => {
        const templates = {
            simple: '<!DOCTYPE html>\n' +
'<html>\n' +
'<body style="font-family: Arial, sans-serif; padding: 20px; background-color: #f4f4f4;">\n' +
'    <div style="max-width: 600px; margin: 0 auto; background: white; padding: 30px; border-radius: 10px;">\n' +
'        <h1 style="color: #333;">' + '{{subject}}' + '</h1>\n' +
'        <p style="color: #666; font-size: 16px; line-height: 1.6;">' + '{{content}}' + '</p>\n' +
'        <a href="' + '{{verification_link}}' + '" style="display: inline-block; background: #007bff; color: white; padding: 12px 30px; text-decoration: none; border-radius: 5px; margin-top: 20px;">\n' +
'            Devam Et\n' +
'        </a>\n' +
'    </div>\n' +
'</body>\n' +
'</html>',
            
            professional: '<!DOCTYPE html>\n' +
'<html lang="tr">\n' +
'<head>\n' +
'    <meta charset="UTF-8">\n' +
'</head>\n' +
'<body style="margin: 0; padding: 0; background-color: #f6f9fc;">\n' +
'    <table width="100%" cellpadding="0" cellspacing="0">\n' +
'        <tr>\n' +
'            <td align="center" style="padding: 40px 20px;">\n' +
'                <table width="600" cellpadding="0" cellspacing="0" style="background: white; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.08);">\n' +
'                    <tr>\n' +
'                        <td style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 50px 40px; text-align: center; border-radius: 12px 12px 0 0;">\n' +
'                            <h1 style="color: white; margin: 0; font-size: 32px; font-weight: 700;">MyCourse Galaxy</h1>\n' +
'                            <p style="color: rgba(255,255,255,0.9); margin: 10px 0 0; font-size: 16px;">Eğitimde Yeni Bir Çağ</p>\n' +
'                        </td>\n' +
'                    </tr>\n' +
'                    <tr>\n' +
'                        <td style="padding: 40px;">\n' +
'                            <h2 style="color: #1a1a1a; margin: 0 0 20px; font-size: 24px;">Merhaba,</h2>\n' +
'                            <div style="color: #525f7f; font-size: 16px; line-height: 1.8;">\n' +
'                                ' + '{{content}}' + '\n' +
'                            </div>\n' +
'                            <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 30px;">\n' +
'                                <tr>\n' +
'                                    <td align="center">\n' +
'                                        <a href="' + '{{verification_link}}' + '" style="display: inline-block; background: #667eea; color: white; padding: 16px 50px; text-decoration: none; border-radius: 8px; font-weight: 600; font-size: 16px; box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);">\n' +
'                                            Hemen Başla\n' +
'                                        </a>\n' +
'                                    </td>\n' +
'                                </tr>\n' +
'                            </table>\n' +
'                        </td>\n' +
'                    </tr>\n' +
'                    <tr>\n' +
'                        <td style="background: #f8fafc; padding: 30px 40px; border-radius: 0 0 12px 12px; text-align: center;">\n' +
'                            <p style="color: #8898aa; font-size: 14px; margin: 0;">© 2026 MyCourse Galaxy. Tüm hakları saklıdır.</p>\n' +
'                        </td>\n' +
'                    </tr>\n' +
'                </table>\n' +
'            </td>\n' +
'        </tr>\n' +
'    </table>\n' +
'</body>\n' +
'</html>',
            
            minimal: '<!DOCTYPE html>\n' +
'<html>\n' +
'<body style="font-family: \'Segoe UI\', Tahoma, Geneva, Verdana, sans-serif; margin: 0; padding: 40px; background: #fafafa;">\n' +
'    <div style="max-width: 500px; margin: 0 auto; background: white; padding: 40px; border-left: 4px solid #667eea;">\n' +
'        <h2 style="color: #2d3748; margin: 0 0 20px; font-weight: 600;">' + '{{subject}}' + '</h2>\n' +
'        <p style="color: #4a5568; font-size: 15px; line-height: 1.7; margin: 0 0 25px;">' + '{{content}}' + '</p>\n' +
'        <a href="' + '{{verification_link}}' + '" style="color: #667eea; text-decoration: none; font-weight: 600; font-size: 15px;">→ Devam Et</a>\n' +
'        <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 30px 0;">\n' +
'        <p style="color: #a0aec0; font-size: 13px; margin: 0;">MyCourse Galaxy</p>\n' +
'    </div>\n' +
'</body>\n' +
'</html>'
        };
        
        setHtmlTemplate(templates[templateType]);
        toast.success(templateType + ' template yüklendi!');
    };

    const emailCount = parseEmails(emailList).length;

    return (
        <div className="email-template-editor">
            <div className="editor-header">
                <h2>📧 Email Template Editörü</h2>
                <p>HTML formatında özel email template'leri oluşturun ve gönderin</p>
            </div>

            {/* Template Seçici */}
            <div className="template-selector">
                <h3>Hızlı Template Seç</h3>
                <div className="template-buttons">
                    <button onClick={() => loadTemplate('simple')} className="template-btn">
                        📄 Basit
                    </button>
                    <button onClick={() => loadTemplate('professional')} className="template-btn">
                        💼 Profesyonel
                    </button>
                    <button onClick={() => loadTemplate('minimal')} className="template-btn">
                        ✨ Minimal
                    </button>
                </div>
            </div>

            {/* Kampanya Bilgileri */}
            <div className="form-section">
                <div className="form-row">
                    <div className="form-group">
                        <label>Kampanya Adı</label>
                        <input
                            type="text"
                            value={campaignName}
                            onChange={(e) => setCampaignName(e.target.value)}
                            placeholder="Örn: Yaz İndirimi 2026"
                        />
                    </div>
                    <div className="form-group">
                        <label>Email Konusu</label>
                        <input
                            type="text"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            placeholder="Email konusu"
                        />
                    </div>
                </div>
            </div>

            {/* İçerik */}
            <div className="form-section">
                <label>Email İçeriği ({'{{'+'content'+'}}'} yerine gelecek)</label>
                <textarea
                    value={bodyContent}
                    onChange={(e) => setBodyContent(e.target.value)}
                    placeholder="Email içeriğinizi buraya yazın..."
                    rows={5}
                    className="content-textarea"
                />
                <small className="help-text">
                    Bu içerik, HTML template'inizdeki <code>{"{{content}}"}</code> yerine yerleştirilecektir.
                </small>
            </div>

            {/* Tab Navigator */}
            <div className="tab-navigator">
                <button 
                    className={`tab-btn ${activeTab === 'editor' ? 'active' : ''}`}
                    onClick={() => setActiveTab('editor')}
                >
                    💻 HTML Editor
                </button>
                <button 
                    className={`tab-btn ${activeTab === 'preview' ? 'active' : ''}`}
                    onClick={() => setActiveTab('preview')}
                >
                    👁️ Önizleme
                </button>
            </div>

            {/* HTML Editor / Preview */}
            <div className="editor-container">
                {activeTab === 'editor' ? (
                    <div className="html-editor">
                        <label>HTML Template</label>
                        <textarea
                            value={htmlTemplate}
                            onChange={(e) => setHtmlTemplate(e.target.value)}
                            placeholder="HTML template kodunuzu buraya yazın..."
                            rows={20}
                            className="html-textarea"
                            spellCheck={false}
                        />
                        <div className="editor-hints">
                            <small>💡 Kullanılabilir placeholder'lar:</small>
                            <ul>
                                <li><code>{"{{subject}}"}</code> - Email konusu</li>
                                <li><code>{"{{content}}"}</code> - Email içeriği</li>
                                <li><code>{"{{body}}"}</code> - Email içeriği (alternatif)</li>
                                <li><code>{"{{verification_link}}"}</code> - Doğrulama linki</li>
                            </ul>
                        </div>
                    </div>
                ) : (
                    <div className="preview-container">
                        <div className="preview-header">
                            <strong>Konu:</strong> {subject}
                        </div>
                        <iframe
                            srcDoc={getPreviewHtml()}
                            title="Email Preview"
                            className="preview-iframe"
                        />
                    </div>
                )}
            </div>

            {/* Email Listesi */}
            <div className="form-section">
                <label>
                    Email Listesi 
                    {emailCount > 0 && (
                        <span className="email-count"> ({emailCount} geçerli email)</span>
                    )}
                </label>
                <textarea
                    value={emailList}
                    onChange={(e) => setEmailList(e.target.value)}
                    placeholder="Email adreslerini girin (her satıra bir email)&#10;&#10;Örnek:&#10;user1@example.com&#10;user2@example.com&#10;user3@example.com"
                    rows={8}
                    className="email-list-textarea"
                />
                <small className="help-text">
                    Email adreslerini virgül, noktalı virgül veya yeni satır ile ayırabilirsiniz.
                </small>
            </div>

            {/* Gönder Butonu */}
            <div className="action-buttons">
                <button 
                    onClick={handleSendCampaign}
                    disabled={isLoading || emailCount === 0}
                    className="send-btn"
                >
                    {isLoading ? (
                        <>⏳ Gönderiliyor...</>
                    ) : (
                        <>🚀 Kampanya Başlat ({emailCount} Email)</>
                    )}
                </button>
            </div>
        </div>
    );
};

export default EmailTemplateEditor;
